import { configureStore } from "@reduxjs/toolkit";
import config_uiReducer from "./reducers/config_ui.reducer";
import backend_infoReducer from "./reducers/backend_info.reducer";
import media_Reducer from "./reducers/media.reducer";
import favorites_Reducer from "./reducers/favorites.reducer";
import my_media_Reducer from "./reducers/my_media.reducer";
import profile_Reducer from "./reducers/profile.reducer";
import reports_Reducer from "./reducers/reports.reducer";
import withdrawals_Reducer from "./reducers/withdrawals.reducer";

const store =
	configureStore({
		reducer: {
			config_ui: config_uiReducer,
			backend_info: backend_infoReducer,
			media: media_Reducer,
			my_media: my_media_Reducer,
			favorites: favorites_Reducer,
			profile: profile_Reducer,
			reports: reports_Reducer,
			withdrawals: withdrawals_Reducer
		},
		devTools: true
	});

export default store;